import {
  branch,
  compose,
  withPropsOnChange,
  renderComponent,
  setPropTypes,
  setDisplayName,
  defaultProps,
} from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import get from 'lodash/get'
import toString from 'lodash/toString'

import { ApiTransport, getApiState } from '@infotech/lib-api-middleware'
import { DotsSpinner } from '@infotech/base-components'

const createWithLazyEntity = ({
  entitiesSelector,
  dataSelector,
  schemaName,
  fetchApiAction,
  errorComponent = () => `Нет данных`,
  dataPropName = `entityData`,
}) => compose(
  defaultProps({
    errorComponent,
  }),
  setDisplayName(`WithLazyEntity`),
  setPropTypes({
    entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  connect((state, { entityId }) => ({
    entities: entitiesSelector(state),
    apiState: getApiState(state, schemaName, toString(entityId)),
  })),
  branch(
    ({ apiState }) => get(apiState, `isFetching`),
    renderComponent(DotsSpinner),
  ),
  branch(
    ({ apiState }) => get(apiState, `hasError`),
    renderComponent(
      ({ errorComponent }) => (errorComponent()),
    ),
  ),
  branch(
    ({ apiState }) => apiState,
    withPropsOnChange([`entityId`], ({ entityId, entities }) => ({
      [dataPropName]: get(entities, entityId, {}),
    })),
    compose(
      withPropsOnChange([`entityId`], ({ entityId }) => ({
        entity   : schemaName,
        apiAction: fetchApiAction,
        query    : toString(entityId),
        dataSelector,
        spinner  : DotsSpinner,
        dataPropName,
      })),
      ApiTransport,
    ),
  ),
)

export default createWithLazyEntity
